import { Outlet } from 'react-router-dom';

export const EventExternalOutlet = () => <Outlet />;
